export const NAME = 'assignEmail';
export const actionTypes = {
    SET_EMAIL: `${NAME}/SET_EMAIL`,
};
